'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_ScaledRecipe(recipe, scaled, factor, notScaled) {
  this.D2 = null;
  this.zi = false;
  this.D1 = null;
  this.St = null;
  this.D2 = recipe;
  this.zi = scaled;
  this.D1 = factor;
  this.St = notScaled;
}
export { $c_Lmealorama_ScaledRecipe as $c_Lmealorama_ScaledRecipe };
$p = $c_Lmealorama_ScaledRecipe.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ScaledRecipe;
/** @constructor */
function $h_Lmealorama_ScaledRecipe() {
}
export { $h_Lmealorama_ScaledRecipe as $h_Lmealorama_ScaledRecipe };
$h_Lmealorama_ScaledRecipe.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 1731037864);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.D2));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.zi ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.D1));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.St));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_ScaledRecipe)) {
    if ((this.zi === x$0.zi)) {
      var x = this.D2;
      var x$2 = x$0.D2;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.D1;
      var x$4 = x$0.D1;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.St;
      var x$6 = x$0.St;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 4;
});
$p.r = (function() {
  return "ScaledRecipe";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.D2;
      break;
    }
    case 1: {
      return this.zi;
      break;
    }
    case 2: {
      return this.D1;
      break;
    }
    case 3: {
      return this.St;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_ScaledRecipe(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jR)));
}
export { $isArrayOf_Lmealorama_ScaledRecipe as $isArrayOf_Lmealorama_ScaledRecipe };
var $d_Lmealorama_ScaledRecipe = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ScaledRecipe, "mealorama.ScaledRecipe", ({
  jR: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_ScaledRecipe as $d_Lmealorama_ScaledRecipe };
//# sourceMappingURL=mealorama.-Scaled-Recipe.js.map
